import * as firebase from "firebase/app"
import "firebase/storage"
import AppService from "./app-service"

const path = "animal-registrations"

export default class AnimalRegistrationService extends AppService {

  constructor() {
    super({ path })
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data)
  }

  getAttachments(registrationId) {
    return this.http.get(`${path}/${registrationId}/attachments`)
  }

  getPrivateAttachments(registrationId) {
    return this.http.get(`${path}/${registrationId}/attachments?private=true`)
  }

  removeAttachment(registrationId, file) {
    return firebase.storage().ref(`${path}/${registrationId}/attachments`).child(file.name).delete()
  }

  removePrivateAttachment(registrationId, file) {
    return firebase.storage().ref(`${path}/${registrationId}/private-attachments`).child(file.name).delete()
  }

  findCerts(registrationId) {
    return this.http.get(`${path}/${registrationId}/certs`)
  }
}